import {
  BrandPageHeaderLoading,
  InlineFilterLoading,
  NavigationTreeLoading,
  STREAM_TOP_SPACING,
  StreamHeaderLoading,
} from '@aboutyou/logic-components';
import {SplitView} from '@aboutyou/ui-components';
import React from 'react';
import styled from 'styled-components';
import {ProductStreamSkeleton} from '../CategoryPage/ProductStreamSkeleton';

export const BrandShopPageSkeleton: React.FC = () => {
  return (
    <div data-ssr-skeleton="BrandShopPageSkeleton">
      <BrandPageHeaderLoading landscape />
      <SplitView
        split={'30:70'}
        splitMedium={'20:80'}
        splitLarge={'15:85'}
        reducePadding
        contentStart={<NavigationTreeLoading />}
        contentEnd={
          <ContentSection>
            <StreamHeaderLoading />
            <InlineFilterLoading />
            <ProductStreamSkeleton />
          </ContentSection>
        }
      />
    </div>
  );
};

const ContentSection = styled.section`
  padding-top: ${STREAM_TOP_SPACING}px;
`;
